export default {
    namespaced: true,
    state: {
        configuracionCliente: null
    },
    mutations: {
        actualizarConfiguracion(state, configuracion) {
            state.configuracionCliente = configuracion;
        },
        resetearConfiguracion(state) {
            state.configuracionCliente = null;
        }
    },
    actions: {
        async obtenerConfiguracion({ commit }, navigation_url) {
            try {
                commit('resetearConfiguracion');
                const response = await axios.post('/api/configuracion/cliente', { navigation_url });

                if (response.data.redirect) {
                    window.location.href = "https://movired.cl";
                    return;
                }

                commit('actualizarConfiguracion', response.data);
            } catch (error) {
                console.error(error);
                throw error;
            }
        }
    }
};
